module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic1.bc97e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic1.png
// module id = 560
// module chunks = 1